import { render, staticRenderFns } from "./UserMailSettings.vue?vue&type=template&id=09a5f36c"
import script from "./UserMailSettings.vue?vue&type=script&lang=js"
export * from "./UserMailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports